import React, {useEffect, useState} from "react";
import {Button, Modal} from "antd";
import {RoundFullCheckIcon} from "../../../assets/icons/RoundFullCheckIcon";
import {BigInput} from "../../forms/bigInput/BigInput";
import "./rename-flow.css";
import {renameFlow} from "../../../api/renameFlow";
import useUserContext from "../../../hooks/useUserContext";
import useAppContext from "../../../hooks/useAppContext";

interface RenameFlowProps {
    flowId: number;
    flowTitle: string;
    onClose: () => void;
    isOpen: boolean;
}

const RenameFlow = ({ isOpen, flowId, flowTitle, onClose }: RenameFlowProps) => {
    const [title, setTitle] = useState(flowTitle);
    const { selectedDomain } = useUserContext();
    const { actions: { loadFlows }} = useAppContext();
    const [isLoading, setIsLoading] = useState(false);

    const rename = async () => {
        selectedDomain && title && await renameFlow(selectedDomain, flowId, title);
        loadFlows();
        onClose();
    }

    useEffect(() => {
        isOpen && setTitle(flowTitle);
    }, [isOpen]);

    return (
        <Modal className="rename-modal-container" open={isOpen} closeIcon={true} okButtonProps={{ style: { display: 'none' }}} cancelButtonProps={{ style: { display: 'none' }}} onCancel={onClose}>
            <div className="rename-flow">
                <div className="title">Rename Flow</div>
                <div className="sub-title">Give your flow a name to help you identify it internally. This name is for your reference only and won’t be visible to your clients.</div>
                <div className="rename-form">
                    <div className="top">
                    <BigInput value={title} setValue={setTitle} />
                    </div>
                    <div className="bottom">
                        <Button size="large" disabled={isLoading} type="text" onClick={onClose}>Cancel</Button>
                        <Button size="large" disabled={isLoading} loading={isLoading} type="primary" icon={<RoundFullCheckIcon width={20} color="#fff" />} onClick={rename}>Rename</Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default RenameFlow;